// src/components/PaymentSuccess.js
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { trackEvent } from "../utils/pixel";
import api from "../api/apiClient";

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const paymentIntentId = searchParams.get("payment_intent");

  useEffect(() => {
    async function verifyPayment() {
      if (!paymentIntentId) return;

      try {
        // Fråga backend om status (du kan ha ett endpoint typ /verify-payment)
        const { data } = await api.get(`/verify-payment?payment_intent=${paymentIntentId}`);

        if (data?.status === "succeeded") {
          // Skicka Facebook Pixel Purchase event
          trackEvent("Purchase", {
            value: data.amount / 100, // stripe ger amount i ören
            currency: "SEK",
          });
        }
      } catch (err) {
        console.error("Verify payment error:", err);
      }
    }

    verifyPayment();
  }, [paymentIntentId]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <h1 className="text-3xl font-bold text-green-600">Tack för ditt köp!</h1>
      <p className="mt-4 text-lg">Din betalning har registrerats.</p>
    </div>
  );
}
